<div class="login-app">
  <div class="login-container">
    <div class="login-company-branding mb-4"></div>
    <router-outlet></router-outlet>
  </div>
</div>
<div class="soft-app-info">
  <img [attr.src]="'./assets/images/softapps-logo.svg'" class="login-softapps-logo" />
  <div>
    <h6 class="font-semibold">SoftApps</h6>
    &copy; Softline IT GmbH 1980-{{ year }} <br />
    {{ version() }}
  </div>
</div>
<soft-modal-container></soft-modal-container>
